import { $http } from '@/utils/https';
import { globalLoader } from '@/helpers/variables';
import type { ActionContext } from 'vuex';
import type { RootState } from '@/store';
import type { NavigationItem } from '@/types/site';
import type { HeaderMessage, VariablesData } from '@/types/api';
import type { ISendMessengerFormPayload } from '@/store/modules/types/messengers';

interface State {
  config: any | null;
  translations: any | null;
  variables: VariablesData | null;
  headerMenu: Array<NavigationItem>;
  headerBanner: any | null;
}

const state: State = {
  config: null,
  translations: null,
  variables: null,
  headerMenu: [],
  headerBanner: null
};

const getters = {
  variables: (state: State) => state.variables,
  translations: (state: State) => state.translations,
  config: (state: State) => state.config,
  headerMenu: (state: State) => state.headerMenu,
  headerBanner: (state: State) => state.headerBanner
};

const actions = {
  GET_HEADER_BANNER: async ({ commit }: any) => {
    try {
      const response = await $http.get(`v1/header_banners`);
      commit('SET_HEADER_BANNER', response.data.data);
      console.log('GET_HEADER_BANNER', response.data.data);

      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
  GET_HEADER_MESSAGES: async () => {
    try {
      const response = await $http.get<{ data: Array<HeaderMessage> }>(`v1/header_messages`);

      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
  GET_HEADER_MENU: async ({ commit }: ActionContext<State, RootState>) => {
    try {
      const response = await $http.get('v1/menu-series');
      commit('SET_HEADER_MENU', response.data.data);
    } catch (e) {
      throw e;
    }
  },
  GET_VARIABLES: async ({ commit }: ActionContext<State, RootState>) => {
    try {
      const response = await $http.get('v1/variables');
      commit('SET_VARIABLES', response.data.data);
    } catch (e) {
      throw e;
    }
  },
  // eslint-disable-next-line no-unused-vars
  GET_TRANSLATIONS: async ({ commit }: ActionContext<State, RootState>) => {
    globalLoader(true);
    try {
      const response = await $http.get('v1/translations');
      commit('SET_TRANSLATIONS', response.data);
      return response.data;
    } catch (e) {
      throw e;
    } finally {
      globalLoader(false);
    }
  },
  // eslint-disable-next-line no-unused-vars
  SEND_MESSENGER_FORM: async ({ commit }: any, payload: ISendMessengerFormPayload) => {
    try {
      const response = await $http.post('v1/store_feedback_form', payload);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  }
};

const mutations = {
  SET_HEADER_BANNER(state: State, data: any) {
    state.headerBanner = data;
  },
  SET_HEADER_MENU(state: State, list: Array<NavigationItem>) {
    state.headerMenu = list;
  },
  SET_VARIABLES(state: State, data: any) {
    state.variables = data;
  },
  SET_TRANSLATIONS(state: State, data: any) {
    state.translations = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
